import { render } from "./FormDate.vue?vue&type=template&id=4864b68a"
import script from "./FormDate.vue?vue&type=script&lang=js"
export * from "./FormDate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__